import CryptoJS from 'crypto-js';

/* Function to hash values for GA tracking in SHA-256 format */
export const formatStringToSha256Hash = (value?: string): string | undefined => {
  if (!value) {
    return undefined;
  }

  const sanitisedString = value.trim().toLowerCase();
  return CryptoJS.SHA256(sanitisedString).toString(CryptoJS.enc.Hex);
};
